interface AppointmentReasonDisplayProps {
    reason: string | null;
}

/** Read-only counterpart of the dashboard Composer's Reason input — same
 *  bordered box, no presets/typing. */
export function AppointmentReasonDisplay({ reason }: AppointmentReasonDisplayProps) {
    return (
        <div className="w-full rounded-lg border border-gray-200 px-3 py-2.5 text-sm bg-white">
            {reason ? (
                <span className="text-gray-800">{reason}</span>
            ) : (
                <span className="text-gray-400 italic">No reason given</span>
            )}
        </div>
    );
}
